const getLanguageId = () =>{
    const language = JSON.parse(localStorage.getItem("language_id"));
    return language
}
export default getLanguageId
